module.exports = __webpack_public_path__ + "img/left4.0b8545e3.png";